class chooseCheckPersonCtrl {
    constructor($scope, logger, httpRequest, $uibModalInstance, items1) {
        // 选中数据
        let _chooseList = []
        let modalData = {}
        $scope.chooseList = []
        const vm = this
        $scope.modalData = {}
        $scope.chooseSearchVal = ''
        $scope.chooseSearchResult = []
        if (items1.index != -1) {
            modalData = items1.arr[items1.index]
            $scope.modalData.choosetype = modalData.approveType
            $scope.modalData.checkTitle = modalData.stageName
        } else {
            // $scope.modalData.checkTitle = '请创建审批环节名称'
            $scope.modalData.choosetype = '1'
        }

        // 获取数据
        httpRequest.get_qryOrgRoleAndUser().then((res) => {
            if (modalData.wfApproverList) {
                const tempArr = []
                res.data.value.forEach((role) => {
                    role.userList.forEach((user) => {
                        modalData.wfApproverList.forEach((item) => {
                            if (item.userName === user.userName) {
                                tempArr.push(`${role.roleId}_${user.userId}`)
                            }
                        })
                    })
                })
                $scope.selectedOrg = tempArr.join(',')
                $scope.chooseList = arrReduce(tempArr)
            }
            // 机构树
            $scope.orgTree = setUniqueUserId(res.data.value)
            // 缓存原始列表
            _chooseList = getFlaterItem($scope.orgTree)
            // 选中数据
            // $scope.selectedOrg = modalData
        })
        $scope.$watch('modalData.checkTitle', (newVal, oldVal) => {
            if (newVal && newVal.length > 15) $scope.modalData.checkTitle = oldVal
        })
        function setUniqueUserId (treeData) {
            // 设置唯一id
            const result = treeData
            for (const i in result) {
                if (result[i].userList) {
                    for (const a in result[i].userList) {
                        result[i].userList[a].uniqueUserId = `${result[i].roleId}_${result[i].userList[a].userId}`
                    }
                }
            }
            return result
        }

        function getFlaterItem (treeData) {
            // 展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].userList) {
                        recursionTree(nodes[i].userList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.uniqueUserId) {
                    result.push(item)
                }
            })
            return result
        }

        function getSelectedItem (treeData) {
            // 递归树 获取选中项返回展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].userList) {
                        recursionTree(nodes[i].userList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.uniqueUserId && item.selected == true) {
                    result.push(item)
                }
            })
            return result
        }

        // 对象数组针对某一对象属性去重
        function arrReduce (arr) {
            const obj = {}
            return arr.reduce((item, next) => {
                obj[next.userId] ? '' : obj[next.userId] = true && item.push(next)
                return item
            }, [])
        }

        // orgTree用户名一致项统一控制选择状态
        function sameUsernameCtl (node) {
            for (const i in $scope.orgTree) {
                for (const j in $scope.orgTree[i].userList) {
                    if ($scope.orgTree[i].userList[j].userId === node.userId) {
                        $scope.orgTree[i].userList[j].selected = node.selected
                    }
                }
            }
        }

        // 搜索变化
        $scope.chooseSearchValChange = function () {
            const chooseSearchArr = []
            _chooseList.map((item) => {
                if (item.realName.indexOf($scope.chooseSearchVal) != -1) {
                    chooseSearchArr.push(item)
                }
            })
            $scope.chooseSearchResult = arrReduce(chooseSearchArr)
        }

        // 变化
        $scope.chooseSearchSelect = function (node) {
            sameUsernameCtl(node)
            // id数据
            $scope.chooseList = getSelectedItem($scope.orgTree)
            const selectedArr = $scope.chooseList.map((item) => item.uniqueUserId)
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
            // $scope.$broadcast('selectedOrgChange', selectedStr);
        }

        $scope.stChangeHandle = function (data) {
            // 表格数据
            $scope.chooseList = arrReduce(data)
            // id数据
            const selectedArr = data.map((item) => item.uniqueUserId)
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
        }

        // 删除
        $scope.delChosenList = function (id, index) {
            const tmpId = id.slice(id.indexOf('_') + 1)
            const tmpSelId = ''
            // 删除表格数据
            $scope.chooseList.splice(index, 1)
            // 删除id
            const selectedArr = $scope.selectedOrg.split(',')


            const l = selectedArr.length
            for (let i = 0; i < l; i++) {
                if (id == selectedArr[i]) {
                    selectedArr.splice(i, 1)
                }
            }
            const selectedStr = selectedArr.join(',')
            $scope.selectedOrg = selectedStr
            // $scope.$broadcast('selectedOrgChange', selectedStr);
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            if (!$scope.modalData.checkTitle) {
                $scope.errorMsg = '审批环节名称不能为空'
                return
            }
            let count = 0
            if (items1.arr.length) {
                items1.arr.forEach((item, index) => {
                    if (item.stageName === $scope.modalData.checkTitle && index != items1.index) {
                        count++
                    }
                })
            }
            if (count < 1) {
                // 返回数据
                const chooseListLen = $scope.chooseList.length
                if (chooseListLen <= 0) {
                    logger.logError('审批人不能为空')
                    return
                }

                for (let i = 0; i < chooseListLen; i++) {
                    $scope.chooseList[i].chooseType = $scope.modalData.choosetype
                    if ($scope.modalData.choosetype === '1') {
                        $scope.chooseList[i].chooseTypeText = '或签'
                    } else {
                        $scope.chooseList[i].chooseTypeText = '会签'
                    }
                }
                // 重新组装选中id
                const selectedUserIdArr = $scope.chooseList.map((item) => item.userId)
                const selectedUserId = selectedUserIdArr.join(',')
                $uibModalInstance.close({
                    selectedArr: selectedUserId,
                    selectedList: $scope.chooseList,
                    choosetype: $scope.modalData.choosetype,
                    title: $scope.modalData.checkTitle,
                })
            } else {
                $scope.errorMsg = '审批环节名称已存在'
            }
        }
    }
}


chooseCheckPersonCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$uibModalInstance', 'items1']
export default chooseCheckPersonCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/chooseCheckPersonCtrl.js